import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import { useLocation } from 'react-router-dom';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import useBvReviewsForceMount from 'components/consumer/PDP/BazaarVoice/useBvReviewsForceMount';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const PDPCustomerPhotos = () => {
  const $ = _c(14);
  const variantSku = usePdpFullVariantSku();
  const containerRef = useRef(null);
  const forceMountReviews = useBvReviewsForceMount();
  const location = useLocation();
  const pdpIdentity = `${variantSku}:${location.pathname}`;
  let t0;
  if ($[0] !== pdpIdentity) {
    t0 = {
      identity: pdpIdentity,
      hasMounted: false
    };
    $[0] = pdpIdentity;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [mountLatch, setMountLatch] = useState(t0);
  const hasMounted = mountLatch.identity === pdpIdentity && mountLatch.hasMounted;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rootMargin: "600px 0px"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intersection = useIntersection(containerRef, t1);
  const hasApproachedViewport = intersection?.isIntersecting;
  const shouldMountReviews = hasApproachedViewport || forceMountReviews;
  let t2;
  let t3;
  if ($[3] !== hasMounted || $[4] !== pdpIdentity || $[5] !== shouldMountReviews) {
    t2 = () => {
      if (hasMounted) {
        return;
      }
      if (shouldMountReviews) {
        setMountLatch({
          identity: pdpIdentity,
          hasMounted: true
        });
      }
    };
    t3 = [shouldMountReviews, hasMounted, pdpIdentity];
    $[3] = hasMounted;
    $[4] = pdpIdentity;
    $[5] = shouldMountReviews;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== hasMounted || $[9] !== shouldMountReviews || $[10] !== variantSku) {
    t4 = (hasMounted || shouldMountReviews) && <BVReviews key={variantSku} productId={variantSku} />;
    $[8] = hasMounted;
    $[9] = shouldMountReviews;
    $[10] = variantSku;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div ref={containerRef} className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 min-h-[400px]" id="PDPCustomerPhotos">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default PDPCustomerPhotos;